<template>
    <div class="question-info flex items-center">
        <div class="flex items-center">
            <AttemptResultExpertWidget
                v-if="expertView && attemptId"
                :expert-view="expertView"
                :type-show="quiz.result_attempt.type_show"
                :lesson-id="lessonId"
                :question-id="questionId"
                :attempt-id="attemptId"
                :question="question"
                :user-id="userId"
            />
            <AttemptResultStudentWidget
                :attempt-id="quiz && quiz.attempt && quiz.attempt.id"
                v-else-if="!expertView && question && question && question.has_comments"
                :commentable-id="question.id"
                :comments-count="question.comments_count"
            />

            <!--            <span
                class="number"
                :class="{ show: question && !question.description && $screenWidth <= 500, 'number-large': number > 9 }"
                v-if="hasNumeration"
            >
                {{ number }}.</span
            >-->

            <em class="required-notifier" style="color: #dd4141" v-if="question && question.is_required"> *</em>
        </div>

        <PracticeQuestionDescription
            :number="hasNumeration ? number : 0"
            :description="question.description"
            :question="question"
            :allow-collapse="question.is_collapse_enabled"
        />
    </div>
</template>

<script>
import AttemptResultExpertWidget from "../../common/result/AttemptResultExpertWidget"
import AttemptResultStudentWidget from "../../common/result/AttemptResultStudentWidget"
import PracticeQuestionDescription from "@components/Practice/PracticeQuestions/components/PracticeQuestionDescription.vue"

export default {
    props: {
        expertView: {
            type: Boolean,
            default: false
        },
        userId: {
            type: [Number, String],
            default: 0
        },
        lessonId: {
            type: [Number, String],
            default: 0
        },
        attemptId: {
            type: [Number, String],
            default: 0
        },
        questionId: {
            type: [Number, String],
            default: 0
        },
        question: {
            type: Object,
            default: () => {}
        },
        quiz: {
            type: Object,
            default: () => {}
        },
        number: {
            type: [Number, String],
            default: ""
        },
        name: {
            type: [Number, String],
            default: ""
        }
    },
    components: {
        PracticeQuestionDescription,
        AttemptResultStudentWidget,
        AttemptResultExpertWidget
    },
    name: "PracticeQuestionInfo",
    computed: {
        hasNumeration() {
            const settings = this.quiz.settings || this.quiz
            return (
                this.number &&
                settings &&
                settings.questions_numeration_type &&
                settings.questions_numeration_type.id === 1
            )
        }
    }
}
</script>

<style lang="sass">
.question-info
    padding-bottom: 10px
    .required-notifier
        position: absolute
        top: 5px
        right: 10px
        font-size: 40px
        font-style: normal
    .number
        min-width: 25px
        font-family: Inter, sans-serif
        font-size: 16px
        line-height: 1.5
        color: #B5C1D2
        white-space: nowrap
        padding-right: 5px
        @media (max-width: 500px)
            //display: none
        &.number-large
            min-width: 30px
        &.show
            display: inline
            @media (min-width: 500px)
                //display: none
</style>
